import { FETCH_MANAGER_HOURANALYTICS_SUCCESS } from "../Constants";

const initialState = {
  payload: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MANAGER_HOURANALYTICS_SUCCESS:
      return {
        payload: action.data
      };

    default:
      return state;
  }
};
